export default "__VITE_ASSET__20b28948__"